import { api } from './client';
import type {
  ConversationListItem, ConversationDetail, ChatMessage, ChatUser, Paginated,
} from '@/types';

export const chatApi = {
  async conversations(): Promise<ConversationListItem[]> {
    const { data } = await api.get<Paginated<ConversationListItem>>('/conversations/');
    return data.results ?? (data as unknown as ConversationListItem[]);
  },
  async createDirect(userId: number): Promise<ConversationDetail> {
    const { data } = await api.post<ConversationDetail>('/conversations/', {
      kind: 'direct', user_id: userId,
    });
    return data;
  },
  async createGroup(title: string, memberIds: number[]): Promise<ConversationDetail> {
    const { data } = await api.post<ConversationDetail>('/conversations/', {
      kind: 'group', title, member_ids: memberIds,
    });
    return data;
  },
  async messages(convId: number): Promise<ChatMessage[]> {
    const { data } = await api.get<Paginated<ChatMessage>>(`/conversations/${convId}/messages/`);
    return data.results ?? (data as unknown as ChatMessage[]);
  },
  async sendMessage(convId: number, text: string, files?: File[]): Promise<ChatMessage> {
    if (files && files.length > 0) {
      const form = new FormData();
      if (text) form.append('text', text);
      files.forEach((f) => form.append('files', f));
      const { data } = await api.post<ChatMessage>(
        `/conversations/${convId}/messages/`, form,
        { headers: { 'Content-Type': 'multipart/form-data' } },
      );
      return data;
    }
    const { data } = await api.post<ChatMessage>(`/conversations/${convId}/messages/`, { text });
    return data;
  },
  async markRead(convId: number): Promise<void> {
    await api.post(`/conversations/${convId}/read/`);
  },
  async contacts(): Promise<ChatUser[]> {
    const { data } = await api.get<ChatUser[]>('/conversations/contacts/');
    return data;
  },
  async unreadCount(): Promise<number> {
    const { data } = await api.get<{ unread: number }>('/conversations/unread-count/');
    return data.unread;
  },
};
